import * as Styled from './ChatLoadingIndicator.styled';

/**
 * @type {import('react').FC<{sendingText: boolean}>}
 */
const ChatLoadingIndicator = ({ sendingText }) => {
  return (
    <Styled.LoadingIndicatorWrapper>
      {sendingText && <span>{sendingText}</span>}
      <Styled.LoadingIndicator>
        <span>.</span>
        <span>.</span>
        <span>.</span>
      </Styled.LoadingIndicator>
    </Styled.LoadingIndicatorWrapper>
  );
};

export default ChatLoadingIndicator;
